// FullScreenModal.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { FullScreenModalStyle } from './styles';
import CustomButton from "../general/CustomButton";
import ReactImageFallback from "react-image-fallback";
import defaultProductImage from "../../assets/defaultImages/defaultUpdate.png";

const FullScreenModal = ({ name,  toggleFullScreenModal, imageSrc}) => {
  return (
    <FullScreenModalStyle
        >
          <div className="header">
            <p className="name">{name}</p>
            <div className="buttons">
              <CustomButton
                variant="white"
                icon="close"
                iconOnly
                onClick={toggleFullScreenModal}
              />
            </div>
          </div>
          <div className="body">
            <ReactImageFallback
              src={imageSrc}
              fallbackImage={defaultProductImage}
              alt={name ?? "Imagen del producto"}
              style={{ maxWidth: "100%", maxHeight: "100%" }}
            />
          </div>
        </FullScreenModalStyle>
  );
};

FullScreenModal.propTypes = {
  children: PropTypes.node.isRequired,
  onDragOver: PropTypes.func,
  onDrop: PropTypes.func,
  onDragLeave: PropTypes.func,
};

export default FullScreenModal;